import React from "react";

import { formatCellValue } from "./weeklyEACFormat";
import {
  DIRECT_LABOR_TOTALS_COLUMN_WIDTHS,
  TOTALS_GROUP_WIDTH,
} from "./weeklyEACColumns";
import {
  getEmployeeItdTotal,
  getEmployeeRemainingForecastTotal,
  getEmployeeGrandTotal,
} from "./weeklyEACCalculations";

const TOTAL_GROUPS = [
  {
    key: "itd",
    label: "ITD",
    getTotal: getEmployeeItdTotal,
    headerClass: "actualHeaderCost",
  },
  {
    key: "remainingForecast",
    label: "Remaining Forecast",
    getTotal: getEmployeeRemainingForecastTotal,
    headerClass: "forecastHeaderCost",
  },
  {
    key: "total",
    label: "Total",
    getTotal: getEmployeeGrandTotal,
    headerClass: "forecastHeaderCost",
  },
];

export default function WeeklyEACDirectLaborTotalsTable({
  employeeDetails,
  allEmployeeDetails,
}) {
  return (
    <table className="thirdTableFin weeklyEac" cellPadding={0} cellSpacing={0}>
      <thead>
        <tr>
          {TOTAL_GROUPS.map((group) => (
            <th
              key={group.key}
              colSpan={2}
              className="centerAlignedHeaderLeftBorder"
              style={{
                minWidth: TOTALS_GROUP_WIDTH,
                maxWidth: TOTALS_GROUP_WIDTH,
              }}
            >
              {group.label}
            </th>
          ))}
        </tr>
        <tr>
          {TOTAL_GROUPS.map((group) => (
            <React.Fragment key={group.key}>
              <th
                className={group.headerClass}
                style={{
                  minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                  maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                }}
              >
                Total Hours
              </th>
              <th
                className={group.headerClass}
                style={{
                  minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                }}
              >
                Total Burden Cost
              </th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {employeeDetails.map((employee) => (
          <tr key={employee.dlId}>
            {TOTAL_GROUPS.map((group, index) => (
              <React.Fragment key={group.key}>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    paddingLeft: "4px",
                    borderLeft: "1px solid #ccc",
                  }}
                  title={formatCellValue(group.getTotal(employee, "hours"), "number")}
                >
                  {formatCellValue(group.getTotal(employee, "hours"), "number")}
                </td>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  }}
                  title={formatCellValue(
                    group.getTotal(employee, "burdenCost"),
                    "currency",
                  )}
                >
                  {formatCellValue(
                    group.getTotal(employee, "burdenCost"),
                    "currency",
                  )}
                </td>
              </React.Fragment>
            ))}
          </tr>
        ))}
        <tr className="totalRow">
          {TOTAL_GROUPS.map((group, index) => {
            const totalHours = allEmployeeDetails.reduce(
              (sum, employee) => sum + group.getTotal(employee, "hours"),
              0,
            );
            const totalBurdenCost = allEmployeeDetails.reduce(
              (sum, employee) => sum + group.getTotal(employee, "burdenCost"),
              0,
            );
            return (
              <React.Fragment key={group.key}>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.hours,
                    paddingLeft: "4px",
                    borderLeft: "1px solid #ccc",
                  }}
                  title={formatCellValue(totalHours, "number")}
                >
                  {formatCellValue(totalHours, "number")}
                </td>
                <td
                  style={{
                    minWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                    maxWidth: DIRECT_LABOR_TOTALS_COLUMN_WIDTHS.burdenCost,
                  }}
                  title={formatCellValue(totalBurdenCost, "currency")}
                >
                  {formatCellValue(totalBurdenCost, "currency")}
                </td>
              </React.Fragment>
            );
          })}
        </tr>
      </tbody>
    </table>
  );
}
